export const transactionStyle = {
  noBorder: {
    border: "none",
    padding: "10px",
  },
  typography: { width: "100%", marginTop: "24px", fontWeight: "bold" },

  box: { width: "100%", marginTop: "16px" },

  tableCell: {
    border: "none",
    padding: "10px",
    fontWeight: "bold",
    fontSize: 16,
    width: "40%",
  },
  pullDetail: {
    border: "none",
    padding: "10px",
    fontWeight: "bold",
    fontSize: 16,
    width: "20%",
  },
};
